import type { Category } from "@/types/content";

export const categories: Category[] = [
  {
    slug: "variety",
    name: "综艺幕后",
    short: "综艺",
    desc: "棚内棚外的临场反应、嘉宾互动与游戏环节筹备现场，还原一档节目从录制到成片的全过程。",
    icon: "ri-mic-line",
    count: 186,
  },
  {
    slug: "film",
    name: "影视探班",
    short: "影视",
    desc: "剧组开机到杀青之间的真实日常，从定妆围读到夜戏收工，记录影像作品背后的时间线。",
    icon: "ri-film-line",
    count: 243,
  },
  {
    slug: "crew",
    name: "剧组江湖",
    short: "剧组",
    desc: "灯光、场务、服化道、生活制片各司其职，一部戏背后数百人的协作生态与行业规矩。",
    icon: "ri-team-line",
    count: 158,
  },
  {
    slug: "backstage",
    name: "幕后故事",
    short: "幕后",
    desc: "台本之外的临时改动、临场救场与计划外的意外，往往比正片更值得回味。",
    icon: "ri-magic-line",
    count: 271,
  },
  {
    slug: "onsite",
    name: "拍摄现场",
    short: "现场",
    desc: "机位怎么摆、雨戏怎么等、几百号人如何在同一分钟内安静下来，现场调度的一手见闻。",
    icon: "ri-camera-lens-line",
    count: 204,
  },
  {
    slug: "editing",
    name: "剪辑台",
    short: "剪辑",
    desc: "哪些镜头最终没有出现在成片里，节奏、时长与情绪如何被一刀一刀重新塑造。",
    icon: "ri-scissors-cut-line",
    count: 132,
  },
];